module.exports = __webpack_public_path__ + "img/photo-projects-yummytours.82269da1.png";